import React from 'react'

const primaryColor = 'rgba(20, 28, 236, 1)'

export default () => {
	return(
		<header className="container__header">
      <div className="container__header__content">
        <h1>
          Hello, I'm Thomas Hoadley,<br/>
          a digital product designer and developer.
        </h1>
        <div className="header__description header__description--desktop">
          <p><span className="header__description__icon">+</span>Focused on crafting functional, aesthetic digital products</p>
          <p><span className="header__description__icon">+</span>for start-ups, agencies and organisations.</p>
          <p><span className="header__description__icon">+</span>Hire me at <a href="mailto:info@thomashoadley.co.uk" className="header__description__link">info@thomashoadley.co.uk</a>.</p>
        </div>
        <div className="header__description header__description--mobile">
          <p>Focused on crafting functional, aesthetic digital products for start-ups, agencies and organisations.</p>
          <br/>
          <p>Hire me at <a href="mailto:info@thomashoadley.co.uk" className="header__description__link">info@thomashoadley.co.uk</a>.</p>
        </div>        
      </div>
		</header>
	)
}


/** WEBPACK FOOTER **
 ** ./js/components/header.js
 **/